import { useNavigate } from "react-router-dom";
import ContentPage from "./modules/Content";

function PageNotFound(){
      const navigate = useNavigate();
    return (
        <>
            <ContentPage>
                <div class="container">
                    <div class="card" >
                        <div class="card-body">
                            <h3 class="card-title">PAGE 403</h3>
                            <h6 class="card-subtitle mb-2 text-muted">Autorisation requise</h6>
                            <p class="card-text">Désolé vous n'avez pas les droits d'accès requis pour cette page. Veuillez contacter l'administrateur pour en savoir plus</p>
                            {/* <a href="#" class="card-link">Card link</a> */}
                            <a href="#" class="card-link" onClick={()=>{localStorage.removeItem('_token_');navigate('/auth')}}>Se Deconnecter</a>
                        </div>
                    </div>
                </div>
            </ContentPage>
        </>
    )
}
export default PageNotFound;